/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { SizePerPageRendererOptions } from 'react-bootstrap-table-next';

function TableSizePerPage({ options, onSizePerPageChange, currSizePerPage }: SizePerPageRendererOptions) {
    return (
        <div className="dropdown d-inline">
            <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {currSizePerPage}
            </button>
            <ul className="dropdown-menu">
                {options.map(({ page, text }) => (
                    <li className="dropdown-item" key={page} onClick={() => onSizePerPageChange(page)}>{text}</li>
                ))}
            </ul>
        </div>
    );
}

export default TableSizePerPage;
